import React from 'react';
import { connect } from 'react-redux';
import { Translation } from 'react-i18next';
import i18n from 'i18next';
import { camelCase } from 'lodash';
import SkillInfoValueBar from './SkillInfoValueBar';
import { getSkills, getSkillsCourses } from '../../../../store/actions';
import { getSkillsState } from '../../../../store/selectors';
import Loading from '../../Loading';

export class Skills extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount = async () => {
    await this.props.getSkills();
    if (this.canSeeCourseRecommendations) {
      await this.props.getSkillsCourses();
    }
  };

  filterSkillsCourses = (skillTitleEn) => {
    const skillId = this.props.skills.skills[skillTitleEn].id;
    return this.props.skills.skillsCourses.skillsCourses.filter(
      (x) => x.skill_area_id === skillId
    );
  };

  get canSeeCourseRecommendations() {
    return this.props.tenant.features.includes('skills_course_recommendations');
  }

  get skillsCopy() {
    return {
      communication: {
        english: 'Communication',
        translated: i18n.t('Communication', { context: 'Skills' }),
      },
      computerTechnical: {
        english: 'Computer/Technical',
        translated: i18n.t('Computer/Technical', { context: 'Skills' }),
      },
      criticalThinking: {
        english: 'Critical Thinking',
        translated: i18n.t('Critical Thinking', { context: 'Skills' }),
      },
      interpersonal: {
        english: 'Interpersonal',
        translated: i18n.t('Interpersonal', { context: 'Skills' }),
      },
      problemSolving: {
        english: 'Problem Solving',
        translated: i18n.t('Problem Solving', { context: 'Skills' }),
      },
      mathematics: {
        english: 'Mathematics',
        translated: i18n.t('Mathematics', { context: 'Skills' }),
      },
      creativity: {
        english: 'Creativity',
        translated: i18n.t('Creativity', { context: 'Skills' }),
      },
    };
  }

  displaySkillInfoValueBars = (skillCopy, i) => {
    const { english: skillTitleEn, translated: skillTitle } = skillCopy;
    const { career } = this.props;
    const propTitle = camelCase(skillTitleEn);
    const description = this.props.skills.skills[skillTitleEn]?.description;
    let filteredCourses = [];

    if (this.canSeeCourseRecommendations) {
      filteredCourses = this.filterSkillsCourses(skillTitleEn);
    }

    return (
      <SkillInfoValueBar
        key={i}
        skillTitle={skillTitle}
        skillValue={career[`${propTitle}`]}
        propTitle={propTitle}
        tenant={this.props.tenant}
        description={description}
        courses={filteredCourses}
        carouselClassName={this.props.carouselClassName}
      />
    );
  };

  displayLoading = () => {
    return (
      !this.props.skills ||
      this.props.skills.skills.length === 0 ||
      (this.canSeeCourseRecommendations &&
        (!this.props.skills.skillsCourses ||
          this.props.skills.skillsCourses.length === 0))
    );
  };

  render() {
    return this.displayLoading() ? (
      <Loading height="100%" />
    ) : (
      <Translation>
        {(t) => (
          <div id="skills-section" className="skills-section">
            <p className="skills-section__header">{t('Skills')}</p>
            <p className="skills-section__main-description">
              {t(
                'Job-specific skills are the knowledge, abilities and experiences needed to perform and excel in a particular career.'
              )}
            </p>
            {Object.values(this.skillsCopy).map((skillCopy, i) =>
              this.displaySkillInfoValueBars(skillCopy, i)
            )}
          </div>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = (state) => {
  const tenant = state.tenant;
  const skills = getSkillsState(state);
  return { tenant, skills };
};

export default connect(mapStateToProps, { getSkills, getSkillsCourses })(
  Skills
);
